import { ATTENDANCE_SUBVIEW_MODEL } from '../Model/Model';
import PeriodReviewTable from './PeriodReview/PeriodReviewTable';
import AttendanceRequestedTable from './Request/AttendanceRequestedTable';
import SubmissionHistoryTable from './History/SubmissionHistoryTable';

/**
 *
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */
const SubmissionTab = (props) => {
    const {
        subView,
        changeSubViewManage,
        registerAction,
        option,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        search,
        setSearch,
        setBodyForExport,
        selectedList,
        setSelectedList,
        modified,
        setModified,
        activeStep
    } = props;

    return (
        <>
            {subView === ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.PERIOD_REVIEW && (
                <PeriodReviewTable
                    activeStep={activeStep}
                    subView={subView}
                    option={option}
                    changeSubViewManage={changeSubViewManage}
                    registerAction={registerAction}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    modified={modified}
                    setModified={setModified}
                />
            )}
            {subView === ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.REQUESTED && (
                <AttendanceRequestedTable
                    subView={subView}
                    option={option}
                    changeSubViewManage={changeSubViewManage}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    modified={modified}
                    setModified={setModified}
                />
            )}
            {subView === ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.HISTORY && (
                <>
                    <SubmissionHistoryTable
                        subView={subView}
                        option={option}
                        changeSubViewManage={changeSubViewManage}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSimpleSearch={setSimpleSearch}
                        search={search}
                        setSearch={setSearch}
                        setBodyForExport={setBodyForExport}
                        modified={modified}
                        setModified={setModified}
                    />
                </>
            )}
        </>
    );
};

export default SubmissionTab;
